// extracted by mini-css-extract-plugin
export default {"svg":"Socials_svg__+4AUe","imglc":"Socials_imglc__0lfh+"};